import React from "react";

import { faPlug } from "@fortawesome/pro-regular-svg-icons";

import { useProviderManifest } from "src/api/connectApi/queries";
import { CustomIcon } from "src/connections/config/CustomIcon";
import { NodeIcon, NodeIconSize } from "src/design-system/NodeIcon";
import { useWorkspaceAndOrg } from "src/utils/useCurrentWorkspace";

type Props = {
  provider: string;
  manifestVersion?: string;
  size: NodeIconSize;
};

export const ManifestIcon: React.FC<Props> = ({
  provider,
  manifestVersion,
  size,
}) => {
  const workspaceData = useWorkspaceAndOrg();
  const manifest = useProviderManifest(
    workspaceData.workspace?.base_url,
    provider,
    manifestVersion || "latest",
  ).data;

  // S3-promoted manifests store the logo as an S3 media_key on env_configs
  // (no GitHub commit for the logo). GitHub-promoted manifests commit the
  // logo as a file referenced by icon_path. Pick the right source.
  if (manifest?.meta?.s3_promoted) {
    const mediaKey = (manifest?.environment_configs?.production?.constants
      ?.media_key ?? null) as string | null;
    if (mediaKey) {
      return <CustomIcon size={size} mediaKey={mediaKey} />;
    }
  }

  // If there's no icon specified in the manifest, default to the CC default one
  if (!manifest?.icon_path) {
    return <NodeIcon icon={faPlug} size={size} />;
  }

  return (
    <NodeIcon
      alt={`${provider} Icon`}
      dataLoc={`${provider}-icon`}
      imageSrc={manifest.icon_path}
      size={size}
    />
  );
};
